export default __webpack_public_path__ + "static/media/courses-1.0076d37e.jpg";